module.exports = __webpack_public_path__ + "BlackCraneCreations.webp?e6012ff4aa248cf02f8d1ef25ce7b7a4";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/BlackCraneCreations.webp
// module id = 53
// module chunks = 0